import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import {
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import { useAppSelector } from "utils/hooks/storeHooks";
import { selectFilterRoleOptions } from "store/filterRole/selectors";
import { getRolesAsFilterOptions } from "store/filterRole/thunks";
import variables from "../../styles/partials/_variables.module.scss";
import MoreOptionsBtn from "components/MoreOptionsBtn/MoreOptionsBtn";

export type RoleData = {
  description: string;
  id: number;
  name: string;
  membersCount?: number;
};

const RolesTable = () => {
  const dispatch = useDispatch();
  const roles = useAppSelector(selectFilterRoleOptions);

  const rows: RoleData[] = useMemo(() => {
    const typesOfRoles: RoleData[] = [];
    if (roles) {
      roles.forEach((role) => {
        if (role.name) {
          typesOfRoles.push({
            description: role.description,
            id: role.id,
            name: role.name,
            membersCount: role.membersCount,
          });
        }
      });
    }
    return typesOfRoles;
  }, [roles]);

  useEffect(() => {
    dispatch(getRolesAsFilterOptions());
  }, [dispatch]);

  return (
    <TableContainer
      component={Paper}
      style={{ maxHeight: 400, width: "100%", padding: "1.3rem 0.5rem" }}
    >
      <Table>
        <TableBody sx={{ backgroundColor: variables.backgroundwhite }}>
          {rows.map((row: RoleData) => (
            <TableRow key={row.id}>
              <TableCell
                align="left"
                color={variables.tableGray}
                component="th"
                scope="row"
              >
                <Typography color="black" variant="body1">
                  {row.name}
                </Typography>
                <Typography color={variables.tableGray} variant="body1">
                  {row.description}
                </Typography>
              </TableCell>
              <TableCell align="left" color={variables.neutralGray3}>
                {row.membersCount}{" "}
                {row.membersCount === 1 ? "member" : "members"}
              </TableCell>
              <TableCell align="right" sx={{ paddingLeft: "0.5rem" }}>
                <MoreOptionsBtn
                  crudId={row.id}
                  memberCount={row.membersCount}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default RolesTable;
